import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import api from '../../../services/api';
import { obterIdTenent } from '../../../services/seguranca';
import { useAppSelector } from '../../../store/hooks';
import ModalForm from '../../../components/modal-form';
import { TipoFormulario } from '../../../services/constantes';
import { Campo, Opcao } from '../../../services/tipos';
import { NFServiceService } from '../../../services/NFServiceService';
import { NFService } from '../../../services/tipos';

interface ModalEditarAgendamentoProps {
    show: boolean;
    onHide: () => void;
    onSuccess: () => void;
    nota: NFService | null;
}

const ModalEditarAgendamento: React.FC<ModalEditarAgendamentoProps> = ({ show, onHide, onSuccess, nota }) => {
    const [loading, setLoading] = useState(false);
    const [servicos, setServicos] = useState<Opcao[]>([]);
    const token = useAppSelector((state) => state.token);

    useEffect(() => {
        if (show && nota) {
            carregarDados();
        }
    }, [show, nota]);

    const carregarDados = async () => {
        try {
            const servicosRes = await api.get(`/ServicoNFSePorEmpresa/${obterIdTenent(token)}`);
            setServicos(servicosRes.data.map((s: any) => ({
                label: `${s.codigo} - ${s.descricao}`,
                valor: s.id
            })));
        } catch (error) {
            console.error("Erro ao carregar dados", error);
            toast.error("Erro ao carregar dados para edição.");
        }
    };

    const campos: Campo[] = [
        {
            linha: 1,
            coluna: 1,
            largura: 6,
            nome: "dataHoraEmissao",
            label: "Data da Emissão",
            tipo: "date",
            required: true
        },
        {
            linha: 1,
            coluna: 2,
            largura: 6,
            nome: "valor",
            label: "Valor (R$)",
            tipo: "money",
            required: true
        },
        {
            linha: 2,
            coluna: 1,
            largura: 12,
            nome: "idServico",
            label: "Serviço",
            tipo: "select",
            required: true,
            opcoes: servicos
        },
        {
            linha: 3,
            coluna: 1,
            largura: 12,
            nome: "descricao",
            label: "Descrição do Pagamento",
            tipo: "memo",
            required: false
        },
    ];

    const handleSalvar = async (dados: any) => {
        if (!nota) return;
        setLoading(true);
        try {
            await NFServiceService.editarAgendamento(
                nota.id,
                dados.idServico,
                dados.dataHoraEmissao,
                dados.valor,
                dados.descricao
            );
            toast.success("Agendamento atualizado com sucesso!");
            onSuccess();
            onHide();
        } catch (error: any) {
            console.error(error);
            toast.error("Erro ao processar: " + (error.response?.data?.Mensagem || error.message));
        } finally {
            setLoading(false);
        }
    };

    return (
        <ModalForm
            show={show}
            modo={TipoFormulario.tpEdicao}
            tamanho="lg"
            campos={campos}
            carregando={loading}
            onHide={onHide}
            onCancel={onHide}
            onSave={handleSalvar}
            titulo="Editar Agendamento de Nota"
            entidadeSelecionada={nota ? {
                ...nota,
                descricao: nota.descricaoPagamento, 
            } : undefined}
            apiConfig={{
                endpoint: "dummy",
                requisicaoBemSucedida: () => {},
                tratarErro: () => {},
                idTenentCampo: 'idEmpresa'
            }}
        />
    );
};

export default ModalEditarAgendamento;
